import { render, staticRenderFns } from "./RoughAssessment.vue?vue&type=template&id=4c4821d2&scoped=true&"
import script from "./RoughAssessment.vue?vue&type=script&lang=js&"
export * from "./RoughAssessment.vue?vue&type=script&lang=js&"
import style0 from "./RoughAssessment.vue?vue&type=style&index=0&id=4c4821d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4821d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VRadio,VRadioGroup})
